import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * ç¨æ·å¤´å
 */
@JsonObject
export class Avatar {
  /**
   * ç¨æ·å¤´åå¾ççåªä½èµæºId
   */
  @JsonProperty('mediaId', Number)
  mediaId: number = undefined;
}
